"use client";

import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TechnologyExecution() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = ["Invisalign Şeffaf Plak Tedavisi", "Estetik Safir ve Seramik Braketler", "Lingual (Diş Arkası) Görünmez Teller", "Çocuklar İçin Erken Dönem Ortodonti"];
  return <section data-section-id="40715" id="our-orthodontic-services" ref={ref} className={`w-full py-16 md:py-24 bg-background text-foreground transition-opacity duration-1000 ease-in-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="w-full relative rounded-sm overflow-hidden shadow-md border border-primary/30 bg-muted/10">
            <AspectRatio ratio={16 / 9}>
              <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_5630-1-scaled.jpg" alt="Modern ortodontik tedavi odası ve ekipmanları" className="object-cover w-full h-full hover:scale-105 transition-transform duration-1000" />
              {}
              <div className="absolute inset-0 bg-primary/5 pointer-events-none" />
            </AspectRatio>
          </div>

          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-5xl font-serif tracking-tight text-foreground">
                Modern Ortodonti ile Kusursuz Gülüş Tasarımı
              </h2>
              <p className="text-lg font-sans text-muted-foreground leading-loose">
                Gülüşünüz, en değerli imzanızdır. Uzman kadromuz ve en yeni teknolojilerimizle, 
                her yaş grubuna özel estetik ve fonksiyonel ortodontik çözümler sunarak 
                hayalinizdeki değişimi gerçeğe dönüştürüyoruz.
              </p>
            </div>

            <ul className="space-y-4">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <div className="mt-1 flex-shrink-0 rounded-full bg-primary/10 p-1">
                    <Check className="w-4 h-4 text-primary stroke-[1.5px]" />
                  </div>
                  <span className="text-foreground/90 font-sans font-medium">{feature}</span>
                </li>)}
            </ul>

            <div className="pt-4">
              <Button asChild variant="secondary" size="lg" className="group border border-primary/40 bg-transparent text-primary hover:bg-primary/5 hover:text-primary transition-all duration-300">
                <Link to="/TreatmentsPage">
                  Tedavi Seçeneklerini Keşfedin
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}